<template>
  <SbSelect
    v-model="selectedMatchType"
    v-bind="filter.matchTypeProps"
    :options="matchTypeOptionsList"
    option-label="name"
    option-value="key"
  />
</template>

<script>
import SbSelect from '@src/components/Select/SbSelect.vue';

export default {
  name: 'DropdownMatchTypes',
  components: {
    SbSelect,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    matchType: {
      type: String,
      required: true,
    },
  },
  emits: ['update:match-type'],
  computed: {
    matchTypeOptionsList() {
      return this.filter.matchTypes;
    },
    internalMatchType: {
      get() {
        return this.matchType ?? this.filter.defaultMatchType;
      },
      set(value) {
        this.$emit('update:match-type', value);
      },
    },
    selectedMatchType: {
      get() {
        const value = this.internalMatchType;
        return this.matchTypeOptionsList.find((x) => x.key === value).key;
      },
      set(value) {
        this.internalMatchType = value;
      },
    },
  },
};
</script>
